import { useFormatMessage, type FormatMessages } from "@skilitics/localization";
import type { NodeRole } from "@skilitics/nautilus-core";
import type { NodeTemplateQueryParams } from "@skilitics/nautilus-endpoint-definition";

import { getNodeRoleLabel, useGetManifest } from "../../../state/index.ts";

export const useLibraryLabel = (criteria: NodeTemplateQueryParams) => {
  const formatMessage = useFormatMessage(formatStrings);
  const getManifest = useGetManifest();
  const role = criteria.role ?? criteria.include?.find((i): i is { role: NodeRole } => "role" in i && !!i.role)?.role;
  if (role) {
    return getNodeRoleLabel(role as NodeRole)!;
  }

  const typeId =
    criteria.typeId ?? criteria.include?.find((i): i is { typeId: string } => "typeId" in i && !!i.typeId)?.typeId;
  if (typeId) {
    return getManifest(typeId).title;
  }

  return formatMessage("unspecified");
};

const formatStrings = {
  unspecified: {
    en: "Template",
  },
} satisfies FormatMessages;
